// extracted by mini-css-extract-plugin
export default {"container":"SupportPage_container__GQopv","item":"SupportPage_item__0+l4E","title":"SupportPage_title__ZM+GV","contact":"SupportPage_contact__aNp1Q"};